<template>
	<div class="box">
		<div class="header flex flex-align-center mb-8">
			<span style="width: 20px; height: 20px;background:#FE3363;border-radius:50%"></span>
			<p class="fz-12 ml-4" style="color: #3d3d3d">小程序名称</p>
		</div>
		<div class="title mb-8" style="color: #1d2129">
			{{ product_name }}
		</div>
		<div class="goods-img">
			<el-image fit="cover" :src="product_pic" style="height: 181px; width: 100%" alt="" />
			<div class="info flex flex-just-between flex-align-center" v-if="isShow">
				<div class="left yx-color-white">
					<p class="fz-12">
						<span class="fz-16 mr-4">{{ item.commission_rate }}%</span>佣金率
					</p>
					<p class="fz-12 mt-4">¥{{ item.live_price }}直播价</p>
				</div>
				<div class="right fz-14 mr-4">立即查看 ></div>
			</div>
		</div>
	</div>
</template>
<script>
import mixin from '@/mixins';
import { getMiniAppF } from '@/api/common';
export default {
	props: {
		item: {
			type: Object,
			default: () => {},
		},
		nowType: {
			type: Number,
			default: 1,
		},
		customTitle: {
			type: String,
			default: '',
		},
		default_img: {
			type: String,
			default: '',
		},
	},
	mixins: [mixin],
	computed: {
		product_name({ item, nowType, customTitle }) {
			let obj = {
				0: item.product_name,
				1: customTitle || '输入的小程序卡片标题将会在此处展示...',
				2: item.product_name || '小程序卡片标题将会在此处展示...',
				3: customTitle,
			};
			return obj[nowType];
		},
		product_pic({ item, nowType, default_img }) {
			let img = default_img || require('./img/share-default.png');
			let obj = {
				0: item.product_pic,
				1: img,
				2: item.product_pic || require('./img/share-default.png'),
				3: img,
			};
			return obj[nowType];
		},
		isShow({ nowType, item }) {
			return nowType === 0 || (nowType === 2 && item.product_name);
		},
	},
	data() {
		return {
			minAppIcon: '',
			minAppName: '',
		};
	},
	created() {
		this.initIMG();
	},
	methods: {
		async initIMG() {
			try {
				const { min_app_icon, min_app_name } = await getMiniAppF();
				this.minAppIcon = min_app_icon;
				this.minAppName = min_app_name;
			} catch (error) {
				console.log(error);
			}
		},
	},
};
</script>
<style lang="less" scoped>
.box {
	width: 226px;
	.header {
	}
	.title {
		height: 42px;
		word-break: break-all;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2; /* 这里是超出几行省略 */
		overflow: hidden;
	}
	.goods-img {
		height: 181px;
		position: relative;
		img {
			width: 100%;
			height: 100%;
		}
		.info {
			position: absolute;
			bottom: 6px;
			left: 3px;
			width: 200px;
			padding: 8px 13px 10px 8px;
			border-radius: 6px;
			background-color: #fe3665;
			.right {
				border-radius: 4px;
				padding: 0px 9px;
				height: 30px;
				line-height: 30px;
				background-color: @color-white;
				color: #fe3665;
			}
		}
	}
}
</style>
